<template>
  <div class="fill-height">

    <v-card
        height="100%"
        width="100%"
        class="d-flex flex-column rounded-lg"
        flat
    >
      <v-card-title class="text-break"><strong>{{ $t('cards.titles.spotlight') }}</strong></v-card-title>
      <v-card-text v-if="isLoading" class="d-flex justify-center">
        <v-progress-circular
            color="primary"
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-card-text>
      <v-card-text v-if="!isLoading" class="fill-height pt-0">
        <div v-if="!translatedContentStructures.length">{{ $t('cards.texts.noEvents') }}</div>
        <v-carousel
            dark
            v-if="translatedContentStructures.length"
            :continuous="true"
            :cycle="true"
            :show-arrows="true"
            hide-delimiters
            show-arrows-on-hover
            next-icon="fal fa-chevron-right"
            prev-icon="fal fa-chevron-left"
            delimiter-icon="fal fa-minus"
            light
            hide-delimiter-background
            :interval="10000"
            height="100%"
        >
          <template v-for="(structure, n) in translatedContentStructures">
            <v-carousel-item
                v-if="(n + 1) % columns === 1 || columns === 1"
                :key="'event-slide-' + n"
                eager
            >
              <div class="col-12 ma-0 pa-0 d-flex flex-nowrap">
                <div v-for="(ndx, i) in columns" :key="'column-' + i" class="ma-0 pa-2 py-0" :class="'col-' + (12 / columns)">
                  <template v-if="(n + i) < translatedContentStructures.length">
                    <v-card class="pa-0" tile flat link height="100%" color="transparent">
                      <v-img
                          v-if="translatedContentStructures[i+n].asset.properties && translatedContentStructures[i+n].asset.properties.thumbnailUrl"
                          :src="translatedContentStructures[i+n].asset.properties.thumbnailUrl"
                          :aspect-ratio="16/9"
                          class="grey d-flex justify-start align-end flex-wrap pa-2 rounded-lg overflow-hidden"
                          lazy-src="/assets/img/placeholder.png"
                          eager
                          cover
                          @click.prevent="navigateStructure(translatedContentStructures[i+n])"
                      >
                        <!-- CHIP FOR DURATION FUNXTION -->
                        <v-chip
                            v-if="translatedContentStructures[i+n].translation.duration && translatedContentStructures[i+n].type === 'FUNXTION_VIRTUAL_CLASS'"
                            class="ma-2 rounded-lg"
                            label
                            small
                            color="primary"
                            style="position: absolute; top: 0; right: 0;"
                        >
                          {{ translatedContentStructures[i+n].translation.duration }}
                        </v-chip>
                        <!-- CHIP FOR DURATION VIMEO -->
                        <v-chip
                            v-if="translatedContentStructures[i+n].translation.duration && translatedContentStructures[i+n].type === 'VIMEO'"
                            class="ma-2 rounded-lg"
                            label
                            small
                            color="primary"
                            style="position: absolute; top: 0; right: 0;"
                        >
                          {{ translatedContentStructures[i+n].translation.duration > 3600 ? $moment.utc(translatedContentStructures[i+n].translation.duration*1000).format("HH:mm:ss") : $moment.utc(translatedContentStructures[i+n].translation.duration*1000).format("mm:ss") }}
                        </v-chip>
                        <span class="white--text text-subtitle-1 font-weight-bold" style="text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.4);">{{ translatedContentStructures[i+n].translation.title }}</span>
                      </v-img>
                      <v-img
                          v-else-if="translatedContentStructures[i+n].translation && translatedContentStructures[i+n].translation.thumbnailUrl"
                          :src="translatedContentStructures[i+n].translation.thumbnailUrl"
                          lazy-src="/assets/img/placeholder.png"
                          class="grey d-flex justify-start align-end flex-wrap pa-2 rounded-lg overflow-hidden"
                          :aspect-ratio="16/9"
                          eager
                          cover
                          @click.prevent="navigateStructure(translatedContentStructures[i+n])"
                      >
                        <!-- CHIP FOR DURATION FUNXTION -->
                        <v-chip
                            v-if="translatedContentStructures[i+n].translation.duration && translatedContentStructures[i+n].type === 'FUNXTION_VIRTUAL_CLASS'"
                            class="ma-2 rounded-lg"
                            label
                            small
                            color="primary"
                            style="position: absolute; top: 0; right: 0;"
                        >
                          {{ translatedContentStructures[i+n].translation.duration }}
                        </v-chip>
                        <!-- CHIP FOR DURATION VIMEO -->
                        <v-chip
                            v-if="translatedContentStructures[i+n].translation.duration && translatedContentStructures[i+n].type === 'VIMEO'"
                            class="ma-2 rounded-lg"
                            label
                            small
                            color="primary"
                            style="position: absolute; top: 0; right: 0;"
                        >
                          {{ translatedContentStructures[i+n].translation.duration > 3600 ? $moment.utc(translatedContentStructures[i+n].translation.duration*1000).format("HH:mm:ss") : $moment.utc(translatedContentStructures[i+n].translation.duration*1000).format("mm:ss") }}
                        </v-chip>
                        <span class="white--text text-subtitle-1 font-weight-bold" style="text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.4);">{{ translatedContentStructures[i+n].translation.title }}</span>
                      </v-img>
                      <v-img
                          v-else
                          src="/assets/img/placeholder.png"
                          lazy-src="/assets/img/placeholder.png"
                          class="grey d-flex justify-start align-end flex-wrap pa-2 rounded-lg overflow-hidden"
                          :aspect-ratio="16/9"
                          eager
                          cover
                          @click.prevent="navigateStructure(translatedContentStructures[i+n])"
                      >
                        <!-- CHIP FOR DURATION FUNXTION -->
                        <v-chip
                            v-if="translatedContentStructures[i+n].translation.duration && translatedContentStructures[i+n].type === 'FUNXTION_VIRTUAL_CLASS'"
                            class="ma-2 rounded-lg"
                            label
                            small
                            color="primary"
                            style="position: absolute; top: 0; right: 0;"
                        >
                          {{ translatedContentStructures[i+n].translation.duration }}
                        </v-chip>
                        <!-- CHIP FOR DURATION VIMEO -->
                        <v-chip
                            v-if="translatedContentStructures[i+n].translation.duration && translatedContentStructures[i+n].type === 'VIMEO'"
                            class="ma-2 rounded-lg"
                            label
                            small
                            color="primary"
                            style="position: absolute; top: 0; right: 0;"
                        >
                          {{ translatedContentStructures[i+n].translation.duration > 3600 ? $moment.utc(translatedContentStructures[i+n].translation.duration*1000).format("HH:mm:ss") : $moment.utc(translatedContentStructures[i+n].translation.duration*1000).format("mm:ss") }}
                        </v-chip>
                        <span class="white--text text-subtitle-1 font-weight-bold" style="text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.4);">{{ translatedContentStructures[i+n].translation.title }}</span>
                      </v-img>
                    </v-card>
                  </template>
                </div>
              </div>
            </v-carousel-item>
          </template>
        </v-carousel>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "m2h-spotlight",
  data() {
    return {
      isLoading: false,
      model: null,
      collectionDetails: {},
      series: [],
      spotlight: [],
      structure: {},
      children: [],
      events: [],
      structures: [],
    }
  },
  
  computed: {
    columns() {
      if (this.$vuetify.breakpoint.xl) {
        return 6;
      }

      if (this.$vuetify.breakpoint.lg) {
        return 4;
      }

      if (this.$vuetify.breakpoint.md) {
        return 3;
      }

      if (this.$vuetify.breakpoint.sm) {
        return 2;
      }

      if (this.$vuetify.breakpoint.sm) {
        return 1;
      }

      return 1;
    },

    translatedContentStructures() {
      let structures = [...this.structures]
      structures.forEach((structure) => {
        structure.translation = null
        if (structure.asset && structure.asset.assetTranslations.length){
          //structure.asset.properties.menuTitle = structure.asset.assetTranslations[0].title
          if (structure.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)){
            structure.translation = structure.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)
          }
          /*else if(structure.asset.assetTranslations.find((t) => t.default === true)){
            structure.translation = structure.asset.assetTranslations.find((t) => t.default === true)
          } else {
            structure.translation = structure.asset.assetTranslations[0]
          }*/
        }
      })
      structures = structures.filter((s) => s.translation)
      return structures
    }
  },

  mounted(){
    this.fetchContentStructureSpotlight()
    // this.fetchSpotlight()
    // 803217 JANUARI SPOTLIGHT
    // this.fetchCollectionDetails(817741)
    // this.fetchSeries(817741)
  },

  methods: {
    async fetchContentStructureSpotlight(){
      this.isLoading = true
      let structures = await api.contentStructures.getStructureSpotlight().then((res) => { return res.data })
      if (structures){
        this.structures = structures
      }
      this.isLoading = false
    },
    
    async fetchSpotlight(){
      this.isLoading = true
      let spotlight = []
      spotlight = await api.newsItems.getList("spotlight", this.$i18n.locale).then((res) => { return res.data })
      if (spotlight.length){
        this.spotlight = spotlight.sort((a, b) => {
          return this.$moment(a.created).unix() - this.$moment(b.created).unix()
        })
        if (this.spotlight[0] && this.spotlight[0].properties && this.spotlight[0].properties['spotlightId']){
          /*await this.fetchCollectionDetails(this.spotlight[0].properties['spotlightId'])
          await this.fetchSeries(this.spotlight[0].properties['spotlightId'])*/
            await this.fetchStructure(this.spotlight[0].properties['spotlightId'])
            await this.fetchStructureChildren(this.spotlight[0].properties['spotlightId'])
        }
      }
      this.isLoading = false
    },
      
    async fetchStructure(id){
        this.isLoading = true
        let structure = await api.structures.getStructureById(id).then((res) => { return res.data })
        if (structure){ 
            this.structure = structure
        }
        this.isLoading = false
    },

    async fetchStructureChildren(id){
        this.isLoading = true
        let children = await api.structures.getStructureChildrenById(id).then((res) => { return res.data })
        if (children){ 
            this.children = children.sort((a, b) => { return a.order - b.order })
        }
        this.isLoading = false
    },
    
    async fetchSeries(id){
      this.isLoading = true
      let series = await api.watch.getSeries(id).then((res) => { return res.data })
      if (series){
        this.series = series
      }
      this.isLoading = false
    },
    
    async fetchCollectionDetails(id){
      let collectionDetails = await api.watch.getCategoryDetails(id).then((res) => { return res.data })
      if (collectionDetails){
        this.collectionDetails = collectionDetails
      }
    },

    goToCollection(serie){
      if (serie.type === 'category'){ this.navigate("/browse/" + serie.id) }
      if (serie.type === 'series'){ this.navigate("/series/" + serie.id) }
      if (serie.type === 'file'){ window.open(serie['_links'].source.href, '_blank') }
      /*if (serie.type === 'video'){ this.fetchMovie(serie.id) }*/
      if (serie.type === 'video'){ this.navigate("/videos/" + serie.id) }
    },
      
    goToBestChoices(){
      if (this.spotlight.length && this.spotlight[0].properties['spotlightId']){
          this.navigate('/content/' + this.spotlight[0].properties['spotlightId'])
      }
    },

    navigateStructure(structure){
      /*if (structure.type === 'PDF'){
          this.navigateBlank('/pdf/' + structure.asset.assetId)
      } */
      /*else if (structure.type === 'TYPEFORM'){
          this.navigateBlank('/survey/' + structure.asset.assetId)
      }*/
      if (this.mode === 'challenge' && this.challengeId){
        this.navigate('/challenges/' + this.challengeId + '?str=' + structure.identifier)
      }
      else {
        this.navigate('/content/' + structure.identifier)
      }
    },
    
    navigate(route){
      this.$root.$emit('m2h-loader-show')
      window.location.href = route
    },
  }
}
</script>

<style scoped>

</style>
